import { CreateApiTokenParamsPermissionsEnum } from "@rentablo/api/apiv1";

export type TokenValidity = "30" | "60" | "90" | "365" | "never";

export type CreateTokenFormValues = {
  name?: string;
  permissions: CreateApiTokenParamsPermissionsEnum[];
  validity: TokenValidity;
};

export const ALL_PERMISSIONS = Object.values(
  CreateApiTokenParamsPermissionsEnum
);

export const PERMISSION_TRANSLATION_KEYS: Record<
  CreateApiTokenParamsPermissionsEnum,
  string
> = {
  [CreateApiTokenParamsPermissionsEnum.ACCOUNTS_READ]: "accountsRead",
  [CreateApiTokenParamsPermissionsEnum.ACCOUNTS_WRITE]: "accountsWrite",
  [CreateApiTokenParamsPermissionsEnum.INVESTMENTS_READ]: "investmentsRead",
  [CreateApiTokenParamsPermissionsEnum.INVESTMENTS_WRITE]: "investmentsWrite",
  [CreateApiTokenParamsPermissionsEnum.TRANSACTIONS_READ]: "transactionsRead",
  [CreateApiTokenParamsPermissionsEnum.TRANSACTIONS_WRITE]: "transactionsWrite",
  [CreateApiTokenParamsPermissionsEnum.PROFILE_READ]: "profileRead",
  [CreateApiTokenParamsPermissionsEnum.PROFILE_WRITE]: "profileWrite",
};

export const VALIDITY_TRANSLATION_KEYS: Record<TokenValidity, string> = {
  "30": "days30",
  "60": "days60",
  "90": "days90",
  "365": "oneYear",
  never: "never",
};
